import { TreeItemType } from "@/components/menu-breadcrumbs/enums";
import { GroupModel, QueueTasksModel } from "@/components/menu-breadcrumbs/models";

/**
 * * Модель неймспейса
 */
export class NamespaceModel {
  /**ID неймспейса */
  Id!: string;
  /**ID проекта */
  ProjectId?: number;
  /**Название */
  Name!: string;
  /**ID иконки */
  IconId!: string;
  /**Ссылка на иконку */
  IconUrl!: string;
  /**ID цвета иконки */
  ColorId!: string;
  /**Цвет иконки */
  Color!: string;
  /**Кол-во задач в неймспейсе */
  TasksCount: number = 0;
  /**Админ неймспейса */
  IsAdmin: boolean = false;

  /**Тип в дереве */
  readonly Type: TreeItemType = TreeItemType.Namespace;

  /**Является ли объект рабочей областью */
  isNamespace = (): this is NamespaceModel => true;
  /**Является ли объект группой */
  isGroup = (): this is GroupModel => false;
  /**Является ли объект очередью */
  isQueue = (): this is QueueTasksModel => false;

  constructor(obj?: Partial<NamespaceModel>) {
    Object.assign(this, obj);
  }
}
